{
  "it": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Aggiungi un responsabile",
        "bulk_remove": "Rimuovi dall'attività",
        "change_status": "Cambia stato",
        "confirm": "Contrassegna come completata",
        "create": "Attività",
        "delete": "Elimina responsabile",
        "document_add": "Aggiungi file",
        "document_delete": "Elimina",
        "due_in_month": "Tra un mese",
        "due_in_two_weeks": "Tra due settimane",
        "due_in_week": "Tra una settimana",
        "due_remove": "Rimuovi scadenza",
        "move_to_draft": "Riporta in bozza",
        "open": "Apri",
        "reopen": "Riapri",
        "selectAll": "Seleziona tutte ({total})",
        "send_and_notify": "Invia e notifica",
        "set_due_date": "Imposta scadenza",
        "set_status": "Imposta stato",
        "unSelectAll": "Deseleziona tutto",
        "upload_files": "Carica {count} file | Carica {count} file"
      },
      "assignee_scopes": {
        "external": "Esterno",
        "internal": "Interno"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Membro del team",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Responsabile",
        "assignees": "Responsabili",
        "comment": "Commento",
        "created_at": "Creato",
        "document": "Documento",
        "due_date": "Scadenza",
        "project": "Progetto",
        "status": "Stato",
        "task": "Attività",
        "unit": "Unità"
      },
      "confirm": {
        "affected": "Riguarda {customers} e {team}.",
        "affected_customers": "Riguarda {customers}.",
        "affected_team": "Riguarda {team}.",
        "bulk_affected": "Questo scrive {count} attività. | Questo scrive {count} attività.",
        "bulk_delete_body": "L'attività resta, su questa unità e su tutte le altre. Spariscono solo le righe selezionate.",
        "bulk_delete_header": "Rimuovere queste attività?",
        "complete_body": "Le loro attività vengono chiuse per loro e spariscono dal loro elenco, anche se non hanno fatto nulla.",
        "complete_header": "Chiudere questa attività per tutti?",
        "customer_tasks": "{count} attività per i clienti | {count} attività per i clienti",
        "delete_body": "Scompare solo questa assegnazione. L'attività mantiene gli altri responsabili e le altre unità.",
        "delete_header": "Eliminare {name} da questa attività?",
        "delete_sent_customers": "Questa era già stata inviata, quindi scompare anche dal portale clienti di {unit}.",
        "delete_sent_team": "Questa era già stata inviata, quindi scompare anche dalla lista di {name}.",
        "document_delete_body": "Il file scompare anche dai documenti dell'unità.",
        "document_delete_header": "Eliminare questo file?",
        "draft_body": "L'attività sparisce finché non viene inviata di nuovo. Le e-mail già partite restano inviate.",
        "draft_header": "Riportare questa attività in bozza?",
        "send_customers": "I clienti vedono subito l'attività nel loro portale e ricevono una notifica.",
        "send_header": "Inviare agli assegnatari?",
        "send_permanent": "L'invio non può essere annullato. Riportare l'attività in bozza più tardi non ritira la notifica.",
        "send_status": "Passano a Richiesta.",
        "send_team": "I membri del team ricevono una notifica.",
        "team_tasks": "{count} attività per il team | {count} attività per il team"
      },
      "deep_link": {
        "completed": "Questo compito è già completato.",
        "gone": "Questo compito non è più aperto."
      },
      "empty": {
        "filtered_description": "Modifica i tuoi filtri o cancellali per vedere tutte le assegnazioni.",
        "filtered_title": "Nessuna assegnazione corrisponde ai tuoi filtri",
        "none_title": "Nessuna assegnazione"
      },
      "filters": {
        "due_window_values": {
          "month": "In scadenza entro un mese",
          "none": "Nessuna scadenza",
          "overdue": "In ritardo",
          "week": "In scadenza entro una settimana"
        },
        "show_only": "Mostra solo",
        "show_only_values": {
          "customers": "Clienti",
          "mine": "Assegnate a me",
          "team": "Team"
        }
      },
      "labels": {
        "add_assignee": "Aggiungi un responsabile",
        "add_customers": "Aggiungi clienti",
        "already_assigned": "Questa attività è già stata aggiunta a questa unità.",
        "already_assigned_project": "Questa attività è già stata aggiunta a questo progetto.",
        "assignees": "Assegnatari",
        "assignees_subtitle": "Ognuno riceve la propria attività, per unità.",
        "assignees_title": "Chi deve farlo",
        "comment_earlier_round": "turno precedente",
        "comment_placeholder": "es. il contatore era difficile da raggiungere, questa è la foto migliore che sono riuscito a fare",
        "comments_none": "Il cliente non ha lasciato alcun commento.",
        "comments_title": "Commenti su questa attività",
        "completed": "Completata",
        "confirm_message": "È sicuro di voler contrassegnare questa attività come completata?",
        "customers": "Clienti",
        "documents_none": "Non è stato ancora caricato nulla.",
        "documents_title": "File di questo compito",
        "earlier": "+{count} precedenti",
        "my_tasks": "Le mie attività",
        "no_assignees": "Ancora nessun responsabile assegnato.",
        "no_assignments": "Ancora nessuna attività.",
        "no_assignments_task": "Ancora nessuna assegnazione per questa attività.",
        "no_assignments_unit": "Ancora nessuna attività per questa unità.",
        "previous_upload": "caricamento precedente",
        "required": "Questo campo è obbligatorio",
        "selectOne": "Seleziona almeno un'attività.",
        "select_task": "Selezioni un'attività",
        "selected": "{selected} selezionata | {selected} selezionate",
        "set_status_for": "Imposta lo stato di {name}",
        "superseded": "sostituito",
        "totalSelected": "Tutte le {total} selezionate",
        "upload_hint": "Carichi i documenti richiesti per completare questa attività.",
        "uploaded_documents": "Documenti caricati"
      },
      "statuses": {
        "completed": "Completata",
        "draft": "Bozza",
        "requested": "Richiesta"
      },
      "toasts": {
        "bulk_delete": "Attività rimosse",
        "bulk_update": "Attività aggiornate",
        "completed": "Attività completata",
        "create": "Attività creata",
        "delete": "Responsabile eliminato",
        "document_added": "File aggiunto",
        "document_deleted": "File eliminato",
        "reopened": "Attività riaperta",
        "update": "Attività aggiornata"
      }
    }
  }
}
